import * as yup from 'yup';
import {
  addOptionalNullableToSchema,
  emailSchema,
  phoneSchema,
} from '@common/schema';

export const careManagerSchema = yup.object().shape({
  first_name: addOptionalNullableToSchema(yup.string()),
  last_name: addOptionalNullableToSchema(yup.string()),
  email: addOptionalNullableToSchema(emailSchema),
  phone_number: addOptionalNullableToSchema(phoneSchema),
  slack_link: addOptionalNullableToSchema(yup.string()),
});
